export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-6n-c89b67e85bb176f830242ac5cd05db61.webp";